import {
	SET_ORGANIZATIONS,
	SET_ORGANIZATION,
	CLEAR_ORGANIZATIONS,
	CLEAR_ORGANIZATION,
	ADD_ORGANIZATION,
	UPDATE_ORGANIZATION,
	REMOVE_ORGANIZATION,
} from './actionTypes';

export const organization = (state = {}, action) => {
	switch (action.type) {
		case SET_ORGANIZATION:
			return action.payload;
		case UPDATE_ORGANIZATION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ORGANIZATION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ORGANIZATIONS:
			return action.payload;
		case ADD_ORGANIZATION:
			return [...state, action.payload];
		case UPDATE_ORGANIZATION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ORGANIZATION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ORGANIZATIONS:
			return [];
		default:
			return state;
	}
};
